import React, { useState, useContext } from "react";
import "./Profile.css";
import profile from "../Profile";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AuthContext from "../../contexts/AuthProvider";
import { API_URL } from "../../utils/config";
const baseUrl = API_URL;

const Preferences = () => {
  const { t, i18n } = useTranslation("profile");
  const [isDel, setIsDel] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [currPassword, setCurrPassword] = useState("");
  const [currentVisible, setCurrentVisible] = useState(false);
  const navigate = useNavigate();
const { isAuthenticated } = useContext(AuthContext);

  const toggleLanguage = async () => {
    const nextLang = i18n.language === "en" ? "ar" : "en";
    i18n.changeLanguage(nextLang);
    localStorage.setItem("language", nextLang);

    try {
      if (!isAuthenticated) {
        navigate("/login");
        return;
      }
      const response = await fetch(
        `${baseUrl}/api/v1/attnd-venue/auth/update-profile`,
        {
          method: "PUT", // Assuming you want to update the user profile with the new language
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ lang: nextLang }),
        }
      );

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error);
      }

      console.log("Language updated successfully");
      window.location.reload();
    } catch (error) {
      console.error("Error updating language:", error);
      // alert(error);
    }
  };

  const getLangFromLocalStorage = () => {
    return localStorage.getItem("language") || "en";
  };

  const handleDelete = async () => {
    if (isDeleting) return;
    if (!isConfirmed) {
      setIsConfirmed(true);
      return;
    }
    setIsDeleting(true);
    try {
      if (!isAuthenticated) {
        navigate("/login");
        return;
      }
      const response = await fetch(
        `${baseUrl}/api/v1/attnd-venue/auth/delete-account`,
        {
          method: "DELETE",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            lang: getLangFromLocalStorage(),
          },
          body: JSON.stringify({ currentPassword: currPassword }),
        }
      );

      if (!response.ok) {
        if (response.status === 401) {
          navigate("/login");
          throw new Error("Unauthorized access. Please log in again.");
        }
        const error = await response.json();
        throw new Error(error.error);
      }
      localStorage.clear();
      navigate("/");
    } catch (error) {
      console.error("Error deleting the session:", error);
      alert(error);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div className="Preferences">
      {/* Currency */}
      <div className="PreferencesOption">
        <div>
          <p>
            {t("preferences.currency.label")}{" "}
            <span style={{ marginLeft: "6px" }}>|</span>
          </p>
          <p>{profile.currency || t("preferences.currency.default")}</p>
        </div>
        {/* <p className="Change">
          {t("preferences.currency.change")}
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
              fill="#6609F8"
            />
            <path
              d="M12.0014 17.4701C10.6014 17.4701 9.20141 16.9401 8.13141 15.8701C7.85141 15.5901 7.6014 15.2801 7.3714 14.9101C7.1514 14.5601 7.26139 14.1001 7.61139 13.8801C7.96139 13.6601 8.42142 13.7701 8.64142 14.1201C8.81142 14.4001 8.99141 14.6201 9.19141 14.8201C10.7414 16.3701 13.2614 16.3701 14.8114 14.8201C15.4114 14.2201 15.7914 13.4401 15.9214 12.5701C15.9814 12.1601 16.3614 11.8601 16.7714 11.9301C17.1814 11.9901 17.4614 12.3701 17.4114 12.7801C17.2414 13.9701 16.7114 15.0401 15.8814 15.8801C14.8014 16.9401 13.4014 17.4701 12.0014 17.4701Z"
              fill="#6609F8"
            />
            <path
              d="M7.3399 12.08C7.2999 12.08 7.26991 12.08 7.22991 12.07C6.81991 12.01 6.5299 11.6299 6.5899 11.2199C6.7599 10.0299 7.2899 8.95996 8.1199 8.11996C10.2499 5.98996 13.7199 5.98996 15.8599 8.11996C16.1399 8.39996 16.3899 8.70999 16.6199 9.08999C16.8399 9.43999 16.7299 9.89996 16.3799 10.12C16.0299 10.34 15.5699 10.23 15.3499 9.87997C15.1799 9.60997 14.9999 9.37996 14.7999 9.17996C13.2499 7.62996 10.7299 7.62996 9.17989 9.17996C8.57989 9.77996 8.19991 10.56 8.06991 11.43C8.02991 11.81 7.7099 12.08 7.3399 12.08Z"
              fill="#6609F8"
            />
            <path
              d="M7.82031 17.9297C7.41031 17.9297 7.07031 17.5897 7.07031 17.1797V14.5098C7.07031 14.0998 7.41031 13.7598 7.82031 13.7598H10.4903C10.9003 13.7598 11.2403 14.0998 11.2403 14.5098C11.2403 14.9198 10.9003 15.2598 10.4903 15.2598H8.57031V17.1797C8.57031 17.5897 8.24031 17.9297 7.82031 17.9297Z"
              fill="#6609F8"
            />
            <path
              d="M16.1778 10.2403H13.5078C13.0978 10.2403 12.7578 9.9003 12.7578 9.4903C12.7578 9.0803 13.0978 8.7403 13.5078 8.7403H15.4278V6.82031C15.4278 6.41031 15.7678 6.07031 16.1778 6.07031C16.5878 6.07031 16.9278 6.41031 16.9278 6.82031V9.4903C16.9278 9.9103 16.5878 10.2403 16.1778 10.2403Z"
              fill="#6609F8"
            />
          </svg>
        </p> */}
      </div>

      {/* Language */}
      <div
        className="PreferencesOption"
        style={{ cursor: "pointer" }}
        onClick={toggleLanguage}
      >
        <div>
          <p>
            {t("preferences.language.label")}{" "}
            <span style={{ marginLeft: "6px" }}>|</span>
          </p>
          <p>
            {i18n.language === "en"
              ? t("preferences.language.value.en")
              : t("preferences.language.value.ar")}
          </p>
        </div>
        <p className="Change">
          {t("preferences.language.change")}
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
              fill="#6609F8"
            />
            <path
              d="M12.0014 17.4701C10.6014 17.4701 9.20141 16.9401 8.13141 15.8701C7.85141 15.5901 7.6014 15.2801 7.3714 14.9101C7.1514 14.5601 7.26139 14.1001 7.61139 13.8801C7.96139 13.6601 8.42142 13.7701 8.64142 14.1201C8.81142 14.4001 8.99141 14.6201 9.19141 14.8201C10.7414 16.3701 13.2614 16.3701 14.8114 14.8201C15.4114 14.2201 15.7914 13.4401 15.9214 12.5701C15.9814 12.1601 16.3614 11.8601 16.7714 11.9301C17.1814 11.9901 17.4614 12.3701 17.4114 12.7801C17.2414 13.9701 16.7114 15.0401 15.8814 15.8801C14.8014 16.9401 13.4014 17.4701 12.0014 17.4701Z"
              fill="#6609F8"
            />
            <path
              d="M7.3399 12.08C7.2999 12.08 7.26991 12.08 7.22991 12.07C6.81991 12.01 6.5299 11.6299 6.5899 11.2199C6.7599 10.0299 7.2899 8.95996 8.1199 8.11996C10.2499 5.98996 13.7199 5.98996 15.8599 8.11996C16.1399 8.39996 16.3899 8.70999 16.6199 9.08999C16.8399 9.43999 16.7299 9.89996 16.3799 10.12C16.0299 10.34 15.5699 10.23 15.3499 9.87997C15.1799 9.60997 14.9999 9.37996 14.7999 9.17996C13.2499 7.62996 10.7299 7.62996 9.17989 9.17996C8.57989 9.77996 8.19991 10.56 8.06991 11.43C8.02991 11.81 7.7099 12.08 7.3399 12.08Z"
              fill="#6609F8"
            />
            <path
              d="M7.82031 17.9297C7.41031 17.9297 7.07031 17.5897 7.07031 17.1797V14.5098C7.07031 14.0998 7.41031 13.7598 7.82031 13.7598H10.4903C10.9003 13.7598 11.2403 14.0998 11.2403 14.5098C11.2403 14.9198 10.9003 15.2598 10.4903 15.2598H8.57031V17.1797C8.57031 17.5897 8.24031 17.9297 7.82031 17.9297Z"
              fill="#6609F8"
            />
            <path
              d="M16.1778 10.2403H13.5078C13.0978 10.2403 12.7578 9.9003 12.7578 9.4903C12.7578 9.0803 13.0978 8.7403 13.5078 8.7403H15.4278V6.82031C15.4278 6.41031 15.7678 6.07031 16.1778 6.07031C16.5878 6.07031 16.9278 6.41031 16.9278 6.82031V9.4903C16.9278 9.9103 16.5878 10.2403 16.1778 10.2403Z"
              fill="#6609F8"
            />
          </svg>
        </p>
      </div>

      {/* Delete Account */}
      <div
        className="PreferencesOption"
        style={{ cursor: "pointer" }}
        onClick={() => setIsDel(true)}
      >
        <p className="Delete">{t("preferences.deleteAccount.label")}</p>
        <div className="DeleteDiv">
          <p>{t("preferences.deleteAccount.button")}</p>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.0002 6.73046C20.9802 6.73046 20.9502 6.73046 20.9202 6.73046C15.6302 6.20046 10.3502 6.00046 5.12016 6.53046L3.08016 6.73046C2.66016 6.77046 2.29016 6.47046 2.25016 6.05046C2.21016 5.63046 2.51016 5.27046 2.92016 5.23046L4.96016 5.03046C10.2802 4.49046 15.6702 4.70046 21.0702 5.23046C21.4802 5.27046 21.7802 5.64046 21.7402 6.05046C21.7102 6.44046 21.3802 6.73046 21.0002 6.73046Z"
              fill="#DC3545"
            />
            <path
              d="M8.49977 5.72C8.45977 5.72 8.41977 5.72 8.36977 5.71C7.96977 5.64 7.68977 5.25 7.75977 4.85L7.97977 3.54C8.13977 2.58 8.35977 1.25 10.6898 1.25H13.3098C15.6498 1.25 15.8698 2.63 16.0198 3.55L16.2398 4.85C16.3098 5.26 16.0298 5.65 15.6298 5.71C15.2198 5.78 14.8298 5.5 14.7698 5.1L14.5498 3.8C14.4098 2.93 14.3798 2.76 13.3198 2.76H10.6998C9.63977 2.76 9.61977 2.9 9.46977 3.79L9.23977 5.09C9.17977 5.46 8.85977 5.72 8.49977 5.72Z"
              fill="#DC3545"
            />
            <path
              d="M15.2099 22.7496H8.7899C5.2999 22.7496 5.1599 20.8196 5.0499 19.2596L4.3999 9.18959C4.3699 8.77959 4.6899 8.41959 5.0999 8.38959C5.5199 8.36959 5.8699 8.67959 5.8999 9.08959L6.5499 19.1596C6.6599 20.6796 6.6999 21.2496 8.7899 21.2496H15.2099C17.3099 21.2496 17.3499 20.6796 17.4499 19.1596L18.0999 9.08959C18.1299 8.67959 18.4899 8.36959 18.8999 8.38959C19.3099 8.41959 19.6299 8.76959 19.5999 9.18959L18.9499 19.2596C18.8399 20.8196 18.6999 22.7496 15.2099 22.7496Z"
              fill="#DC3545"
            />
            <path
              d="M13.6601 17.25H10.3301C9.92008 17.25 9.58008 16.91 9.58008 16.5C9.58008 16.09 9.92008 15.75 10.3301 15.75H13.6601C14.0701 15.75 14.4101 16.09 14.4101 16.5C14.4101 16.91 14.0701 17.25 13.6601 17.25Z"
              fill="#DC3545"
            />
            <path
              d="M14.5 13.25H9.5C9.09 13.25 8.75 12.91 8.75 12.5C8.75 12.09 9.09 11.75 9.5 11.75H14.5C14.91 11.75 15.25 12.09 15.25 12.5C15.25 12.91 14.91 13.25 14.5 13.25Z"
              fill="#DC3545"
            />
          </svg>
        </div>
      </div>

      {isDel && (
        <div className="delete-event-modal-overlay">
          <div className="delete-account-modal">
            <div className="Header">
              <p>{t("preferences.deleteAccount.modalTitle")}</p>
              <svg
                onClick={() => {
                  setIsDel(false);
                  setIsConfirmed(false);
                }}
                style={{ cursor: "pointer" }}
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="30" height="30" rx="15" fill="#DBDBDB" />
                <path
                  d="M9.92188 20.4531C9.79167 20.3229 9.70573 20.1719 9.66406 20C9.6224 19.8229 9.6224 19.6484 9.66406 19.4766C9.70573 19.3047 9.78906 19.1562 9.91406 19.0312L13.5781 15.3672L9.91406 11.7109C9.78906 11.5859 9.70573 11.4375 9.66406 11.2656C9.6224 11.0938 9.6224 10.9219 9.66406 10.75C9.70573 10.5729 9.79167 10.4193 9.92188 10.2891C10.0469 10.1641 10.1953 10.0807 10.3672 10.0391C10.5443 9.99219 10.7188 9.99219 10.8906 10.0391C11.0677 10.0807 11.2188 10.1615 11.3438 10.2812L15 13.9453L18.6641 10.2891C18.7891 10.1641 18.9349 10.0807 19.1016 10.0391C19.2734 9.99219 19.4453 9.99219 19.6172 10.0391C19.7943 10.0807 19.9453 10.1667 20.0703 10.2969C20.2057 10.4219 20.2943 10.5729 20.3359 10.75C20.3776 10.9219 20.3776 11.0938 20.3359 11.2656C20.2943 11.4375 20.2083 11.5859 20.0781 11.7109L16.4297 15.3672L20.0781 19.0312C20.2083 19.1562 20.2943 19.3047 20.3359 19.4766C20.3776 19.6484 20.3776 19.8229 20.3359 20C20.2943 20.1719 20.2057 20.3203 20.0703 20.4453C19.9453 20.5755 19.7943 20.6641 19.6172 20.7109C19.4453 20.7526 19.2734 20.7526 19.1016 20.7109C18.9349 20.6693 18.7891 20.5833 18.6641 20.4531L15 16.7969L11.3438 20.4609C11.2188 20.5807 11.0677 20.6641 10.8906 20.7109C10.7188 20.7526 10.5443 20.7526 10.3672 20.7109C10.1953 20.6641 10.0469 20.5781 9.92188 20.4531Z"
                  fill="#464646"
                />
              </svg>
            </div>
            <div className="Content">
              {isConfirmed ? (
                <div className="Input-Del">
                  <p>{t("preferences.currentPassword")}</p>
                  <div className="password-input-container-prefix">
                    <input
                      type={currentVisible ? "text" : "password"}
                      value={currPassword}
                      onChange={(e) => setCurrPassword(e.target.value)}
                    />
                    <span
                      className="eye-icon-prefix"
                      onClick={() => setCurrentVisible((v) => !v)}
                    >
                      {currentVisible ? (
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g id="vuesax/outline/eye">
                            <g id="eye">
                              <path
                                id="Vector"
                                d="M12 16.3299C9.61004 16.3299 7.67004 14.3899 7.67004 11.9999C7.67004 9.60992 9.61004 7.66992 12 7.66992C14.39 7.66992 16.33 9.60992 16.33 11.9999C16.33 14.3899 14.39 16.3299 12 16.3299ZM12 9.16992C10.44 9.16992 9.17004 10.4399 9.17004 11.9999C9.17004 13.5599 10.44 14.8299 12 14.8299C13.56 14.8299 14.83 13.5599 14.83 11.9999C14.83 10.4399 13.56 9.16992 12 9.16992Z"
                                fill="#4D4D4D"
                              />
                              <path
                                id="Vector_2"
                                d="M12 21.02C8.23996 21.02 4.68996 18.82 2.24996 15C1.18996 13.35 1.18996 10.66 2.24996 8.99998C4.69996 5.17998 8.24996 2.97998 12 2.97998C15.75 2.97998 19.3 5.17998 21.74 8.99998C22.8 10.65 22.8 13.34 21.74 15C19.3 18.82 15.75 21.02 12 21.02ZM12 4.47998C8.76996 4.47998 5.67996 6.41998 3.51996 9.80998C2.76996 10.98 2.76996 13.02 3.51996 14.19C5.67996 17.58 8.76996 19.52 12 19.52C15.23 19.52 18.32 17.58 20.48 14.19C21.23 13.02 21.23 10.98 20.48 9.80998C18.32 6.41998 15.23 4.47998 12 4.47998Z"
                                fill="#4D4D4D"
                              />
                            </g>
                          </g>
                        </svg>
                      ) : (
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9.47188 15.2799C9.28188 15.2799 9.09187 15.2099 8.94187 15.0599C8.12187 14.2399 7.67188 13.1499 7.67188 11.9999C7.67188 9.60992 9.61187 7.66992 12.0019 7.66992C13.1519 7.66992 14.2419 8.11992 15.0619 8.93992C15.2019 9.07992 15.2819 9.26992 15.2819 9.46992C15.2819 9.66992 15.2019 9.85992 15.0619 9.99992L10.0019 15.0599C9.85187 15.2099 9.66188 15.2799 9.47188 15.2799ZM12.0019 9.16992C10.4419 9.16992 9.17188 10.4399 9.17188 11.9999C9.17188 13.5599 10.4419 14.8299 12.0019 14.8299C13.5619 14.8299 14.8319 13.5599 14.8319 11.9999C14.8319 10.4399 13.5619 9.16992 12.0019 9.16992Z"
                            fill="#464646"
                          />
                          <path
                            d="M5.59984 18.51C5.42984 18.51 5.24984 18.45 5.10984 18.33C4.03984 17.42 3.07984 16.3 2.25984 15C1.19984 13.35 1.19984 10.66 2.25984 8.99998C4.69984 5.17998 8.24984 2.97998 11.9998 2.97998C14.1998 2.97998 16.3698 3.73998 18.2698 5.16998C18.5998 5.41998 18.6698 5.88998 18.4198 6.21998C18.1698 6.54998 17.6998 6.61998 17.3698 6.36998C15.7298 5.12998 13.8698 4.47998 11.9998 4.47998C8.76984 4.47998 5.67984 6.41998 3.51984 9.80998C2.76984 10.98 2.76984 13.02 3.51984 14.19C4.26984 15.36 5.12984 16.37 6.07984 17.19C6.38984 17.46 6.42984 17.93 6.15984 18.25C6.01984 18.42 5.80984 18.51 5.59984 18.51Z"
                            fill="#464646"
                          />
                          <path
                            d="M11.9986 21.02C10.6686 21.02 9.3686 20.75 8.1186 20.22C7.7386 20.06 7.5586 19.62 7.7186 19.24C7.8786 18.86 8.3186 18.68 8.6986 18.84C9.7586 19.29 10.8686 19.52 11.9886 19.52C15.2186 19.52 18.3086 17.58 20.4686 14.19C21.2186 13.02 21.2186 10.98 20.4686 9.81C20.1586 9.32 19.8186 8.85 19.4586 8.41C19.1986 8.09 19.2486 7.62 19.5686 7.35C19.8886 7.09 20.3586 7.13 20.6286 7.46C21.0186 7.94 21.3986 8.46 21.7386 9C22.7986 10.65 22.7986 13.34 21.7386 15C19.2986 18.82 15.7486 21.02 11.9986 21.02Z"
                            fill="#464646"
                          />
                        </svg>
                      )}
                    </span>
                  </div>
                </div>
              ) : (
                <div className="Info">
                  <h5>{t("preferences.deleteAccount.modalInfo")}</h5>
                  <p>{t("preferences.deleteAccount.modalWarning")}</p>
                </div>
              )}
              <div className="Buttons">
                <button
                  onClick={() => {
                    setIsDel(false);
                    setIsConfirmed(false);
                  }}
                  className="Cancel"
                >
                  {t("preferences.deleteAccount.cancel")}
                </button>
                <button className="Del" onClick={handleDelete}>
                  {isDeleting
                    ? t("preferences.deleteAccount.deleting")
                    : t("preferences.deleteAccount.confirm")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <ToastContainer />
    </div>
  );
};

export default Preferences;
